export const okr_competency_permission= {
    required_permission:['view_competency', 'add_competency', 'change_competency', 'delete_competency'],
}